import React, { useMemo } from "react";
import ContextMenu from "../../Components/Utils/ContextMenu/ContextMenu";
import { ContextMenuItem } from "../../Types/ContextMenuItem";
import { getDeleteContextMenuItem } from "../../Utils/ContextMenuStyles";
import styles from "./Library.module.css";

type FolderMenuProps = {
  folderId: string;
  title: string;
  position?: "left" | "right";
  onRename: (id: string, title: string) => void;
  onMove: (id: string, title: string) => void;
  onDelete: (id: string) => void;
};

const FolderMenu = ({ folderId, title, position = "right", onRename, onMove, onDelete }: FolderMenuProps) => {
  const items: ContextMenuItem[] = useMemo(() => [
    {
      title: "Rename",
      icon: "/img/edit.svg",
      onClickHandler: () => onRename(folderId, title),
    },
    {
      title: "Move folder",
      icon: "/img/change.svg",
      onClickHandler: () => onMove(folderId, title),
    },
    getDeleteContextMenuItem(
      "Delete folder",
      () => onDelete(folderId),
      true,
      {
        title: "Delete folder?",
        message: `Delete "${title}" and everything inside it? This cannot be undone.`,
        severity: "danger",
        icon: "/img/trash-red.svg",
      }
    ),
  ], [folderId, title, onRename, onMove, onDelete]);

  return (
    <ContextMenu items={items} contextId={folderId} position={position}>
      <button type="button" className={styles.iconButton} aria-label={`Folder actions for ${title}`}>
        <img src="/img/menu-meatballs.svg" alt="" />
      </button>
    </ContextMenu>
  );
};

export default FolderMenu;
